import React, { useState } from "react"
import { useStaticQuery, graphql } from "gatsby"
export interface AwardsBlockProps {}

const AwardsBlock: React.SFC<AwardsBlockProps> = () => {

  const award1 = require("../../images/awards-image/en/image1.jpg")
  const award2 = require("../../images/awards-image/en/image2.jpg")
  const award3 = require("../../images/awards-image/en/image3.jpg")


  const query = useStaticQuery(graphql`
    query {
      allFile(
        filter: {
          extension: { regex: "/(jpg)|(png)|(jpeg)/" }
          relativeDirectory: { eq: "awards-image" }
        }
      ) {
        nodes {
          base
          childImageSharp {
            fluid(
              maxWidth: 400
              maxHeight: 320              
              jpegQuality: 50
            ) {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    }
  `)
  const [awards, setAwards] = useState([
    {
      image: award1,
      text: "Sponsored by IEEE",
      linkText: "2nd place in the world",
      subText: "AI Competition",
      link: "https://couger.co.jp/news/2020/06/29/cvpr2020-2nd-place/",
    },
    {
      image: award2,
      text: "Sponsored by Facebook Research",
      linkText: "3rd place in the world",
      subText: "VR/AR Recognition Accuracy Competition",
      link: "https://couger.co.jp/news/2019/10/16/facebook_open_eds/",
    },
    {
      image: award3,
      text: "Computer Vision",
      linkText: "World Top 10",
      subText: "International Conference CVPR 2019 workshop",
      link: "https://couger.co.jp/news/2019/05/21/cvpr2019/",
    },
  ])
  return (
    <div className="container-full content-awards">
      <div className=" u-text-center">
        <h3>Top Ranked in Major Competitions Worldwide</h3>
        <p>
        The visually specialized AI technology behind VisualCortex has achieved various results around the world.
        </p>
        <div className="row">
          {awards.map((award, i) => (
            <div className="col-lg-4 col-md-4" key={i}>
              <div className="content-awards__card">
                <div>
                  <div className="zoom-image">
                    {/* <Img fluid={award.image}></Img> */}
                    <img src={award.image} alt=""/>
                  </div>
                  <p>
                    {award.text} <br /> {award.subText}
                  </p>
                  <a
                    href={award.link}
                    target="_blank"
                    rel="noreferrer"
                    className="btn-link"
                  >
                    {award.linkText}
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default AwardsBlock
